module.exports = __webpack_public_path__ + "img/icon_aside_icon2_hover.6e3f0ea0.svg";